var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("hr"),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "4" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    "label-size": "lg",
                    label: _vm.$t("apeironGwApp.programa.clave"),
                  },
                },
                [_c("span", [_vm._v(_vm._s(_vm.programa.clave))])]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "8" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    "label-size": "lg",
                    label: _vm.$t("apeironGwApp.programa.nombre"),
                  },
                },
                [_c("span", [_vm._v(_vm._s(_vm.programa.nombre))])]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "4" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    "label-size": "lg",
                    label: _vm.$t("apeironGwApp.programa.grado"),
                  },
                },
                [_c("span", [_vm._v(_vm._s(_vm.programa.grado))])]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "4" } },
            [
              _c(
                "b-form-group",
                {
                  attrs: {
                    "label-size": "lg",
                    label: _vm.$t("apeironGwApp.programa.nombreInstitucion"),
                  },
                },
                [_c("span", [_vm._v(_vm._s(_vm.nombreInstitucion))])]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isPosgrado
            ? _c(
                "b-col",
                { attrs: { cols: "4" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-size": "lg",
                        label: _vm.$t("apeironGwApp.programa.nombreSede"),
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.nombreSede))])]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isPosgrado
            ? _c(
                "b-col",
                { attrs: { cols: "4" } },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        "label-size": "lg",
                        label: _vm.$t(
                          "apeironGwApp.programa.nombreDependencia"
                        ),
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.nombreDependencia))])]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }